module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"officePictures":"Фото офиса","photo":"0 фотографий | {n} фотография | {n} фотографии | {n} фотографий"}}')
  delete Component.options._Ctor
}
